import { EventQrCode } from "@/features/auth/pages/eventQrSignUp/EventsQr";
import { ScannedQR } from "@/features/auth/pages/eventQrSignUp/ScannedQR";
import { siteRoutes } from "../siteRoutesList";
import HomePage from "@/features/home/Home";
import TrackerPage from "@/features/tracker/TrackerPage";
import { PageDoesntExist } from "@/pageDoesntExist";
import { PrivacyPolicy } from "@/pages/PrivacyPolicy/PrivacyPolicy";
import { TermsOfUse } from "@/pages/TermsOfUse/TermsOfUse";
import { Schedule } from "@/features/schedule/Schedule";
import { Winners } from "@/features/winners/Winners";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { NotificationPage } from "@/features/notifications/components/page/NotificationPage.fetcher";
import FeedbackPage from "@/pages/Feedback/FeedbackPage";
import GamePassPage from "@/pages/GamePass/GamePassPage";
import LeaderboardPage from "@/pages/Leaderboard/LeaderboardPage";

export const miscRoutes = [
  {
    element: HomePage,
    path: siteRoutes["home"],
  },
  {
    element: TrackerPage,
    path: siteRoutes["tracker"],
  },
  {
    element: TermsOfUse,
    path: siteRoutes["terms"],
  },
  {
    element: PrivacyPolicy,
    path: siteRoutes["privacy-policy"],
  },
  {
    element: PageDoesntExist,
    path: siteRoutes["help"],
  },
  {
    element: PageDoesntExist,
    path: siteRoutes["about"],
  },

  {
    element: PageDoesntExist,
    path: siteRoutes["friends"],
  },
  // QR SIGN UP AND EVENT TRACKET
  {
    element: EventQrCode,
    path: siteRoutes["eventQrCode"],
  },
  {
    element: ScannedQR,
    path: `${siteRoutes["scanQrCodeAndSlug"]}:pcId`,
  },
  // Event Schedule and Winners - Currently unused
  {
    element: brand.hasFeature.winners ? Winners : PageDoesntExist,
    path: siteRoutes["winners"],
  },
  {
    element: brand.hasFeature.schedule ? Schedule : PageDoesntExist,
    path: siteRoutes["schedule"],
  },
  /* Notifications feature page */
  {
    element: NotificationPage,
    path: siteRoutes["notifications"],
  },

  {
    path: "/landing",
    element: PageDoesntExist,
  },
  {
    path: "/",
    element: PageDoesntExist,
  },
  {
    element: LeaderboardPage,
    path: siteRoutes["leaderboard"],
  },
  {
    element: GamePassPage,
    path: siteRoutes["gamepass"],
  },

  {
    element: brand.hasFeature.feedback ? FeedbackPage : PageDoesntExist,
    path: siteRoutes["feedback"],
  },
];
